import { Sidebar } from 'src/Elements/Sidebar'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import E3dcLinks from '../Framework/E3dcLinks'
import { Category } from 'src/Elements/Sidebar/Categories'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { useDispatch } from 'react-redux'
import { BottomButtonGroup, MoreBottomActions } from '../BottomBar'
import { useIsWebviewMode } from 'src/Hooks'
import { useUserBottomActions } from 'src/Libs/navigation/hooks'
import { isFlowTheme } from 'src/Libs/utils'

const useStyles = makeStyles()(theme => ({
  nav: {
    paddingLeft: theme.spacing(2),
  },
  collapsedListClass: {
    width: '28%',

    '& #category-subheader, #category-name': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  bottomNavClass: {
    backgroundColor: theme.palette.grey.grey01,
  },
}))

interface Props {
  links: Category[]
  drawerOpen: boolean
  handleDrawerOpenToggle: () => void
}

/**
 * Provides navigation elements for desktop and mobile variant (breakpoint: md)
 */
const Navigation: React.FC<Props> = ({ links, drawerOpen, handleDrawerOpenToggle }) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const dispatch = useDispatch()
  const isWebView = useIsWebviewMode()
  const [bottomActions, activeAction] = useUserBottomActions()

  if (downMd) {
    return (
      <Box>
        <MoreBottomActions links={links} onClose={() => dispatch(appUpdate({ moreActive: false }))} />
        {isWebView && (
          <BottomButtonGroup actions={bottomActions} value={activeAction} bottomNavClass={classes.bottomNavClass} zIndex={theme.zIndex.bottomBar} />
        )}
      </Box>
    )
  }

  return (
    <nav className={classes.nav} role={'navigation'}>
      <Sidebar
        links={links}
        variant={'permanent'}
        open={drawerOpen}
        onClose={handleDrawerOpenToggle}
        collapsible
        collapsedListClass={classes.collapsedListClass}
      >
        {!isFlowTheme && <E3dcLinks />}
      </Sidebar>
    </nav>
  )
}

export default Navigation
